import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { Messages } from '../../../../../../gen-src/Localize';
import {
  TypedBodyCellProps,
  ProjectLocationLinkDisplayComponent,
  PlaceholderTextCell,
  TextCellFormatter,
  cssClass,
} from '../../../../data-catalog-shared';
import { LinkCellFormatter } from './LinkCellFormatter';

const locationCellCssClass = cssClass('locationCell', {
  fontStyle: 'italic',
  color: TabStyles.Typography.Color.Secondary,
});

export function createProjectLocationLinkCellFormatter<TRowData>(
  getLocationId: (rowData: TRowData) => string | null,
  getLocation: (rowData: TRowData) => string | null,
  disableTabIndex = false,
  getIsEmbeddedProperty: (rowData: TRowData) => boolean | null,
  getDisabledFromRowData?: (rowData: TRowData) => boolean,
): React.Factory<TypedBodyCellProps<TRowData>> {
  return function createProjectLocationCell(props: TypedBodyCellProps<TRowData>) {
    return (
      <ProjectLocationLinkDisplayComponent
        // the pathname is constructed using location, that is why location and locationId is
        // interchanged. Will need to correct it later
        location={getLocationId(props.row.data)}
        locationId={getLocation(props.row.data)}
        hiddenLocationElement={<PlaceholderTextCell placeholderText={Messages.PermissionsRequired()} />}

        noneLocationElement={
          <div className={locationCellCssClass}>
            <TextCellFormatter useWidgetsTooltip={true} cellTitle={Messages.NoneLocationToolTip()} text={Messages.None()} />
          </div>
        }

        notApplicableLocationElement={
          <div className={locationCellCssClass}>
            <TextCellFormatter useWidgetsTooltip={true} cellTitle={Messages.NotApplicableLocaitonToolTip()} text={Messages.NotApplicable()} />
          </div>
        }
        isEmbedded={getIsEmbeddedProperty(props.row.data)}
        linkComponent={
          ({ pathname }) =>
            <LinkCellFormatter
              text={getLocation(props.row.data)}
              pathname={pathname}
              noPadding={false}
              disableTabIndex={disableTabIndex}
              disabled={getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false}
            />
        } />
    );
  };
}
